import React from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { CSidebar, CSidebarNav } from '@coreui/react'

import { AppSidebarNav } from './AppSidebarNav'

import SimpleBar from 'simplebar-react'
import 'simplebar-react/dist/simplebar.min.css'

// sidebar nav config
import navigation from '../_nav'

const AppSidebar = () => {
  const dispatch = useDispatch()
  const unfoldable = useSelector((state) => state.sidebarUnfoldable)
  const sidebarShow = useSelector((state) => state.sidebarShow)

  return (
    <CSidebar
      position="fixed"
      unfoldable={unfoldable}
      visible={sidebarShow}
      onVisibleChange={(visible) => {
        dispatch({ type: 'set', sidebarShow: visible })
      }}
    >
      <div className="d-flex align-items-center gap-2 fw-bold" aria-label="FusionPhish brand">
        <svg
          className="logo-img"
          width="38"
          height="38"
          viewBox="0 0 200 200"
          role="img"
          aria-label="Fusion logo"
          xmlns="http://www.w3.org/2000/svg"
        >
          <title>Fusion</title>
          <path
            d="M20 20 H180 V130 Q180 170 100 182 Q20 170 20 130 Z"
            fill="#ffffff"
            stroke="#cfd7e6"
            strokeWidth="16"
          />
          <rect x="32" y="32" width="136" height="36" rx="4" fill="#4585C5" />
          <path d="M32 84 H94 V168 Q58 166 41 146 Q32 135 32 120 Z" fill="#050707" />
          <rect x="110" y="84" width="58" height="36" rx="3" fill="#050707" />
        </svg>
        <span className="fs-5">Fusion</span>
      </div>

      <CSidebarNav>
        <SimpleBar>
          <AppSidebarNav items={navigation} />
        </SimpleBar>
      </CSidebarNav>
      {/*
      <CSidebarToggler
        className="d-none d-lg-flex"
        onClick={() => dispatch({ type: 'set', sidebarUnfoldable: !unfoldable })}
      />
      */}
    </CSidebar>
  )
}

export default React.memo(AppSidebar)
